import { createSubtemplate } from "@repo/design-system/lib/client-registry";
import type { SectionKey } from "~/components/job-page/jobpagetemplate/unified-jobpage-template";
import PrintViewEonUk from "~/components/job-page/printview/printview-uk/printview-eon-uk";
import AboutEonUk from "~/components/job-page/subclients/uk/about-eon-uk";
import ApplicationGuideEonUk from "~/components/job-page/subclients/uk/application-guide-eon-uk";
import ApplicationProcessEonUk from "~/components/job-page/subclients/uk/application-process-eon-uk";
import ContactEonUk from "~/components/job-page/subclients/uk/contact-eon-uk";
import HeaderImageEonUk from "~/components/job-page/subclients/uk/headerimage-eon-uk";
import JobAdTemplateEonUk from "~/components/job-page/subclients/uk/jobad-template-eon-uk";
import StickyContactEonUk from "~/components/job-page/subclients/uk/sticky-contact-eon-uk";
import VideoSectionEonUk from "~/components/job-page/subclients/uk/video-section-eon-uk";

export const eonUkDefault = createSubtemplate<SectionKey>({
  name: "uk",
  trigger: () => true,
  showProd: true,
  config: {
    overrides: {
      stickyContact: StickyContactEonUk,
      headerImage: HeaderImageEonUk,
      jobDescription: JobAdTemplateEonUk,
      applicationProcess: ApplicationProcessEonUk,
      contact: ContactEonUk,
      about: AboutEonUk,
      // Custom sections not in base
      video: VideoSectionEonUk,
      applicationGuide: ApplicationGuideEonUk,
      printView: PrintViewEonUk,
    },
    sectionBarItems: [
      { href: "#job", label: "About the role", section: "job" },
      {
        href: "#applicationProcess",
        label: "sectionBar_process",
        section: "applicationProcess",
      },
      { href: "#contact", label: "sectionBar_contact", section: "contact" },
      { href: "#about", label: "E.ON Life", section: "about" },
    ],
    sections: [
      "stickyContact",
      "headerImage",
      "sectionBar",
      "breadcrumb",
      "jobDescription",
      "video",
      "applicationProcess",
      "contact",
      "applicationGuide",
      "about",
      "printView",
    ],
  },
});
